<template>
  <div class="form-rich-text-editor">
    <no-ssr>
      <div>
        <editor-menu-bar v-slot="{ commands, isActive }" :editor="editor">
          <div class="form-rich-text-editor__menu">
            <div class="form-rich-text-editor__menu__group">
              <button
                class="form-rich-text-editor__menu__button"
                :class="{ 'is-active': isActive.bold() }"
                @click="commands.bold"
              >
                <i class="ico ico-bold"></i>
              </button>

              <button
                class="form-rich-text-editor__menu__button"
                :class="{ 'is-active': isActive.italic() }"
                @click="commands.italic"
              >
                <i class="ico ico-italic"></i>
              </button>

              <button
                class="form-rich-text-editor__menu__button"
                :class="{ 'is-active': isActive.underline() }"
                @click="commands.underline"
              >
                <i class="ico ico-underline"></i>
              </button>
            </div>

            <div class="form-rich-text-editor__menu__group">
              <button
                class="form-rich-text-editor__menu__button form-rich-text-editor__menu__button--text"
                :class="{ 'is-active': isActive.heading({ level: 3 }) }"
                @click="commands.heading({ level: 3 })"
              >
                H1
              </button>

              <button
                class="form-rich-text-editor__menu__button form-rich-text-editor__menu__button--text"
                :class="{ 'is-active': isActive.heading({ level: 4 }) }"
                @click="commands.heading({ level: 4 })"
              >
                H2
              </button>
            </div>

            <div class="form-rich-text-editor__menu__group">
              <button
                class="form-rich-text-editor__menu__button"
                :class="{ 'is-active': isActive.bullet_list() }"
                @click="commands.bullet_list"
              >
                <i class="ico ico-list-bullet"></i>
              </button>

              <button
                class="form-rich-text-editor__menu__button"
                :class="{ 'is-active': isActive.ordered_list() }"
                @click="commands.ordered_list"
              >
                <i class="ico ico-list-numbers"></i>
              </button>
            </div>
          </div>
        </editor-menu-bar>
      </div>
      <div class="form-rich-text-editor__editor">
        <editor-content class="text-block" :editor="editor" />
      </div>
    </no-ssr>
  </div>
</template>

<script>
import { Editor, EditorContent, EditorMenuBar } from 'tiptap'
import {
  Heading,
  OrderedList,
  BulletList,
  ListItem,
  Bold,
  Italic,
  Underline,
  History
} from 'tiptap-extensions'

export default {
  name: 'FormRichTextEditor',
  components: {
    EditorContent,
    EditorMenuBar
  },
  props: {
    value: String
  },
  data() {
    return {
      editor: null
    }
  },
  watch: {
    value(val) {
      // so cursor doesn't jump to start on typing
      if (this.editor && val !== this.value) {
        this.editor.setContent(val, true)
      }
    }
  },
  mounted() {
    this.editor = new Editor({
      extensions: [
        new BulletList(),
        new Heading({ levels: [2, 3, 4] }),
        new ListItem(),
        new OrderedList(),
        new Bold(),
        new Italic(),
        new Underline(),
        new History()
      ],
      content: '<p>This is just a boring paragraph</p>',
      onUpdate: ({ getHTML }) => {
        // https://github.com/scrumpy/tiptap/issues/412
        const html = getHTML().replace(/<p><\/p>/g, '<p><br/></p>')

        this.$emit('input', html)
      },
      onBlur: () => {
        this.$emit('blur')
      }
    })

    this.editor.setContent(this.value)
  },
  beforeDestroy() {
    this.editor.destroy()
  }
}
</script>

<style lang="scss">
.form-rich-text-editor {
  border: 1px solid $border-color;

  &__menu {
    background: $gray-100;
    border-bottom: 1px solid $border-color;
    padding: 0.3rem;
    display: flex;

    &__group {
      display: flex;
      margin: 0 0.4rem 0 0;
      border: 1px solid $gray-200;
    }

    &__button {
      padding: 3px;
      width: 30px;
      height: 30px;
      background: #fff;
      margin: 0;
      font-size: 14px;
      border-right: 1px solid $gray-200;

      &:last-child {
        border-right: none;
      }

      &--text {
        font-weight: bold;
        font-size: 12px;
      }

      &.is-active {
        background: $gray-100;
      }
    }
  }

  &__editor {
    padding: 0.75rem 1rem;

    > .text-block {
      margin-top: 0;
    }

    .ProseMirror {
      min-height: 300px;
      outline: none;
    }
  }
}
</style>
